<template>
  <div id="verify-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        config-module="910"
        :is-append-query="true"
        :reset="true"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        :lob="'AE'"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <div slot="operations">
          <!--查看-->
          <el-button :disabled="!selectedJob" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
          <!--新增-->
          <el-button type="primary" @click="onAdd()">{{ $t('common.btn.new') }}</el-button>
          <!--复制-->
          <el-button :disabled="!selectedJob" type="primary" @click="copyJobHandler()">{{ $t('SeaExport.Clone') }}</el-button>
          <!--审核通过-->
          <el-button v-show="btn.acceptRole" :disabled="!(selectedJob && selectedJob.jobState === -1 && (![2,3,5].includes(selectedJob.preverifyState) || btnCooperateEnable))" type="primary" @click="acceptHandler()">{{ $t('SeaExport.PassAudit') }}</el-button>
          <!--拒绝-->
          <el-button v-show="btn.rejectRole" type="primary" @click="rejectHandler()">{{ $t('SeaExport.Refuse') }}</el-button>
          <!--复核通过 preverifyState=2 是已审核-->
          <el-button v-show="btn.reviewThrough && btn.pretrialReviewConfig" :disabled="!(selectedJob && selectedJob.preverifyState === 2)" type="primary" @click="btVerifyReviewThroughHandler()">{{ $t('SeaExport.VerifyReviewThrough') }}</el-button>
          <!--复核拒绝-->
          <el-button v-show="btn.reviewRefusal && btn.pretrialReviewConfig" :disabled="!(selectedJob && selectedJob.preverifyState === 2)" type="primary" @click="btVerifyReviewRefusalHandler()">{{ $t('SeaExport.VerifyReviewRefusal') }}</el-button>
          <el-checkbox v-model="cbAutoRefresh" :disabled="true" style="padding-left: 5px">{{ $t('SeaExport.AutomaticallyRefresh') }}</el-checkbox>
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid-wrapper
          config-module="191000"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="finalColumnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          :show-row-groups="dataListDragGroup"
          :darg-group-show-column-def="dargGroupShowColumnDef"
          style="width: 100%;"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="!appendQuery && total>0"
          config-module="191001"
          :total="total"
          :page-count="pageCount"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :selected-row-count="selectedRowCount"
          @pagination="toQueryByPage"
        />
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="total"
            layout="total"
          />
        </div>
      </div>
    </div>
    <!--审核通过-->
    <accept-dialog
      v-if="acceptDialog.visible"
      :visible.sync="acceptDialog.visible"
      :job-model="acceptDialog.job || {}"
      :submit-call-back="acceptDialog.submitCallBack"
      :job-list="acceptDialog.jobs"
    />
    <!--拒绝-->
    <reject-dialog
      v-if="rejectWindow.visible"
      :visible.sync="rejectWindow.visible"
      :job-no="rejectWindow.jobNo"
      :job-list="rejectWindow.jobList"
      :reject-call-back="rejectWindow.rejectCallBack"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
    />
    <!-- 信控验证弹框 -->
    <confirm-dialog-window
      v-if="confirmDialogWindow.visible"
      :visible.sync="confirmDialogWindow.visible"
      :message-title="confirmDialogWindow.messageTitle"
      :content="confirmDialogWindow.content"
      :show-confirm-btn="confirmDialogWindow.showConfirmBtn"
      :confirm-call-back="confirmDialogWindow.confirmCallBack"
    />
    <!-- 协作状态审核 -->
    <cooperation-verify-dialog
      v-if="cooperationVerifyDialog.visible"
      :visible.sync="cooperationVerifyDialog.visible"
      :job-uuid="cooperationVerifyDialog.jobUuid"
      :cooperate="cooperationVerifyDialog.cooperate"
      :submit-call-back="cooperationVerifyDialog.submitCallBack"
      :editable="cooperationVerifyDialog.editable"
    />
    <!-- 多条业务，配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      lob="AE"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
      :new-job="batchCheckingWindow.newJob"
    />
  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { DocumentManage, stopBubble, stringToBool } from '@/utils/commonUtil'
import jobDetailIcon from '@/assets/job-detail.png'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import acceptDialog from '@/views/cargo/v0/AirExport/components/verify/acceptDialog'
import rejectDialog from '@/views/cargo/v0/AirExport/components/verify/rejectDialog'
import { getLoading } from '@/utils/utilBaseElement'
import {
  reviewThrough, reviewRefusal,
  advancedQuery,
  queryLastModifyBookingByDay,
  acceptJob,
  preVerifyReject, batchPreVerifyReject
} from '@/api/AirExport/airExportJob'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import ConfirmDialogWindow from '@/views/cargo/v0/SeaExport/components/verify/ConfirmDialogWindow'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import { batchCheckJobsCredit } from '@/api/booking/job'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import cooperationVerifyDialog from '@/components/Cargo/Job/cooperationVerifyDialog'
import { updateState } from '@/api/booking/jobCooperate'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { getFilterCacheList } from '@/utils/basicDataCache'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'

export default {
  name: 'VerifyTreeGrid',
  components: {
    cargoAgGridWrapper,
    acceptDialog,
    rejectDialog,
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    searchItem,
    cargoTemplateSelectorDialog,
    ConfirmDialogWindow,
    cooperationVerifyDialog,
    BatchCheckingWindow
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    useOrderCenterMode: { type: Boolean, default: false },
    orderCenterBranch: { type: Boolean, default: false },
    approveCooperationBusiness: { type: Boolean, default: false }
  },
  data() {
    return {
      notRefresh: false,
      appendQuery: false, // 追加查询
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      isEditing: false,
      filter: {
        pageNum: 1,
        pageSize: 50,
        branchId: 0, // 分公司ID
        requires: ['aeBookingVerify'], // 空运查询接口共用，用于区分是否订单预审
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      total: 0,
      pageCount: 0,
      selectedJob: null,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              return true
            },
            innerRenderer: params => {
              const methodPath = this.documentManage.getPath('showBusinessInfo')
              return `<span>${params.value}<img src="${jobDetailIcon}" height="16" width="16" style="vertical-align: sub;margin-left:3px;cursor:pointer" onclick="${methodPath}(event)"/></span>`
            }
          }
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        onCellDoubleClicked: event => {
          if (!event.data) {
            return
          }
          this.toLook(event.data)
        },
        onRowClicked: this.onRowClicked,
        onRowSelected: this.onRowSelected,
        defaultColDef: {
          resizable: true
        },
        onSortChanged: (event) => {
          // this.$logger.log('onSortChanged-event', event)
          if (this.rowDataBeforeSort.length !== this.rowData.length) {
            this.rowDataBeforeSort = this.rowData
          }
          if (!event.api.getSortModel().length) {
            this.rowData = this.rowDataBeforeSort
            this.rowDataBeforeSort = []
          } else {
            this.rowData = event.api.getModel().rowsToDisplay.map(item => item.data)
          }
        },
        context: {
          componentParent: this
        },
        onSelectionChanged: (event) => {
          this.selectedRowCount = event.api.getSelectedRows().length
        }
      },
      selectedRowCount: 0,
      dargGroupShowColumnDef: {
        headerName: this.$t('SeaExport.BusinessNo'),
        colId: 'jobNo',
        field: 'jobNo',
        width: 240,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        wrapText: false,
        checkboxSelection: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            return false
          }
          return true
        },
        cellRenderer: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
            return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
          }
          return `<span>${params.value}</span>`
        },
        excelRenderer: params => params.value
      },
      rowData: [],
      gridApi: null,
      documentManage: new DocumentManage(),
      btn: {
        reviewThrough: true, // 复核通过
        reviewRefusal: true, // 复核拒绝
        pretrialReviewConfig: false, // 复核配置
        acceptRole: true, // 审核通过
        rejectRole: true// 拒绝
      },
      rejectWindow: { // 拒绝弹窗
        visible: false,
        jobNo: '',
        jobList: [],
        rejectCallBack: null
      },
      acceptDialog: { // 审核通过弹窗
        visible: false,
        job: null,
        jobs: [], // 当前选中业务
        submitCallBack: null
      },
      templateSelectorDialog: { // 打印弹窗
        visible: false,
        ctx: new AirExportJob(),
        category: '',
        data: {}
      },
      cbAutoRefresh: true,
      confirmDialogWindow: { // 信控验证使用
        visible: false,
        messageTitle: '',
        content: '',
        confirmCallBack: null,
        showConfirmBtn: ''
      },
      creditRestrictionForBooking: 0, // 是否开启预审信控配置(0-不限制，1-弹窗确认，2-强制拦截)
      salesCanSeeBookingAgent: false,
      cooperationVerifyDialog: {
        visible: false,
        jobUuid: '',
        jobUuids: [],
        cooperate: null,
        submitCallBack: this.toAcceptCooperationVerifyCallBack,
        editable: true
      },
      useCheckRule: false, // 是否启用验证规则
      allowPartialCheckPass: false, // CARGO-1677，批量提交业务时，部分业务不符合校验规则导致全部业务都无法提交
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        allowPartialCheckPass: false,
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null
      },
      isZY: false,
      defaultSearchItems: [],
      airMblDisplayStyle: false, // 空运主单号格式
      dataListDragGroup: false // 是否支持数据列表拖拽分组特性
    }
  },
  computed: {
    columnDefs() {
      const result = [
        { headerName: 'MAWB', field: 'mbl', width: 180, colId: 'mbl', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.mawbNoLabelFun(params.value, this.airMblDisplayStyle)
          }
        },
        { headerName: 'HAWB', field: 'hawb', width: 180, colId: 'hawb', enableRowGroup: true },
        { headerName: this.$t('SeaExport.WarehouseNo'), field: 'warehouseNo', width: 180, colId: 'warehouseNo', enableRowGroup: true },
        { headerName: this.$t('SeaExport.FirstLegNo'), field: 'relatedJob2', width: 180, colId: 'relatedJob2', enableRowGroup: true },
        { headerName: this.$t('SeaExport.ConsignationRelationNumber'), field: 'trustFromJob', width: 180, colId: 'trustFromJob', enableRowGroup: true },
        { headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'), field: 'relatedJob', width: 180, colId: 'relatedJob', enableRowGroup: true },
        { headerName: this.$t('SeaExport.ItemNo'), field: 'poNo', width: 180, colId: 'poNo', enableRowGroup: true },
        { headerName: this.$t('SeaExport.CustomerLevel'), field: 'customerTypeId', width: 180, colId: 'customerTypeId', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.companyCustomerTypeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.ContractStatus'), field: 'contractStatus', width: 180, colId: 'contractStatus', enableRowGroup: true },
        { headerName: this.$t('CargoMsg.Cargo_RiskReason'), field: 'riskReason', width: 150, colId: 'riskReason' },
        { headerName: this.$t('SeaExport.SalesOfGoods'), field: 'cargoSalesId', width: 180, colId: 'cargoSalesId', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.CustomerReferenceNumber'), field: 'customerRefNo', width: 180, colId: 'customerRefNo', enableRowGroup: true },
        { headerName: this.$t('SeaExport.OperateType'), field: 'operateType', width: 180, colId: 'operateType',
          cellRenderer: (params) => {
            return ColumnUtils.operateTypeLabelFunc(params.data, 'operateType')
          },
          filter: false,
          filterParams: {}
        },
        { headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'overseaOp', width: 180, hide: true, colId: 'overseaOp', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.ConsignationCompany'), field: 'customerId', width: 180, colId: 'customerId', enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
          }
        },
        { headerName: this.$t('SeaExport.Booking'), field: 'customClaim', width: 180, colId: 'customClaim', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.customClaimLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.CustomsDeclarationType'), field: 'customsClaim2', width: 180, colId: 'customsClaim2', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.customClaim2LabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.AirlineCompany'), field: 'carrierId', width: 180, colId: 'carrierId', enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_6') : ''
          }
        },
        { headerName: this.$t('SeaExport.Flight'), field: 'voyageFlight', width: 180, colId: 'voyageFlight', enableRowGroup: true },
        { headerName: this.$t('SeaExport.LoadingPort'), field: 'loadingPortCode', width: 180, colId: 'loadingPortCode', enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8') : ''
          }
        },
        { headerName: this.$t('SeaExport.PortOfDestination'), field: 'destinationPortCode', width: 180, colId: 'destinationPortCode', enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8') : ''
          }
        },
        { headerName: this.$t('SeaExport.DestinationAgent'), field: 'destinationAgent', width: 180, colId: 'destinationAgent', enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_2') : ''
          }
        },
        { headerName: this.$t('SeaExport.NominatedAgent'), field: 'designationAgent', width: 180, colId: 'designationAgent', enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_3') : ''
          }
        },
        { headerName: this.$t('SeaExport.PortOfHubSecond'), field: 'secondPortCode', width: 180, colId: 'secondPortCode', enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8') : ''
          }
        },
        { headerName: this.$t('SeaExport.PortOfHubThird'), field: 'thirdPortCode', width: 180, colId: 'thirdPortCode', enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8') : ''
          }
        },
        { headerName: this.$t('SeaExport.BookingProperty'), field: 'bookingTerm', width: 180, colId: 'bookingTerm',
          cellRenderer: (params) => {
            return ColumnUtils.bookingTermLabelFunction(params.data, params.value)
          },
          filter: false,
          filterParams: {}
        },
        {
          headerName: this.$t('SeaExport.TaxNature'),
          field: 'taxNature',
          colId: 'taxNature',
          cellRenderer: params => {
            return ColumnUtils.taxNatureLabelFunction(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('Partners.Refuser'),
          colId: 'refuser',
          field: 'refuser',
          hide: true,
          width: 180,
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.preverifyState === 3 ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.data.refuser, 'chineseName') : ''
          },
          valueFormatter: (params) => {
            return params.data.preverifyState === 3 ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName') : ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReturnModule'),
          field: 'returnType',
          colId: 'returnType',
          hide: true,
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            const type = Number(params.data && params.data.returnType)
            if (type === 1) return this.$t('CargoMsg.Cargo_BookingPreAudit')
            if (type === 2) return this.$t('CargoMsg.Cargo_RemoteBooking')
            return ''
          },
          valueGetter: (params) => {
            const type = Number(params.data && params.data.returnType)
            if (type === 1) return this.$t('CargoMsg.Cargo_BookingPreAudit')
            if (type === 2) return this.$t('CargoMsg.Cargo_RemoteBooking')
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReturnReason'),
          field: 'returnRemark',
          colId: 'returnRemark',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DenialReason'),
          colId: 'bookingRefuseNote',
          field: 'bookingRefuseNote',
          hide: true,
          width: 200,
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.preverifyState === 3 ? params.data.bookingRefuseNote : ''
          },
          valueFormatter: (params) => {
            return params.data.preverifyState === 3 ? params.value : ''
          }
        },
        {
          headerName: this.$t('Partners.RefuseDate'),
          colId: 'refuseDate',
          field: 'refuseDate',
          hide: true,
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.preverifyState === 3 ? ColumnUtils.dateLabelFunc(params.data.refuseDate) : ''
          },
          cellRenderer: params => {
            return params.data.preverifyState === 3 ? ColumnUtils.dateLabelFunc(params.value) : ''
          }
        },
        {
          headerName: this.$t('SeaExport.OperationRequirements'),
          field: 'operationContent',
          colId: 'operationContent',
          hide: true,
          enableRowGroup: true,
          width: 180
        },
        {
          headerName: this.$t('SeaExport.specialOperationCode'),
          field: 'specialOperationCode',
          colId: 'specialOperationCode',
          hide: true,
          enableRowGroup: true,
          width: 180
        }
      ]
      if (this.bookingAgentVisible) {
        result.push(
          { headerName: this.$t('SeaExport.BookingAgent'), field: 'bookingAgent', width: 180, colId: 'bookingAgent', enableRowGroup: true,
            cellRenderer: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_1') : ''
            }
          }
        )
      }
      result.push(
        { headerName: this.$t('SeaExport.HaulageCompany'), field: 'carryingCmp', width: 180, colId: 'carryingCmp', enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
          }
        },
        { headerName: this.$t('SeaExport.CommissionedNumberOfPackages'), field: 'quantityContract', width: 180, colId: 'quantityContract', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 0)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.CommissionedGrossWeight'), field: 'weightContract', width: 180, colId: 'weightContract', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.CommissionedVolume'), field: 'cubageContract', width: 180, colId: 'cubageContract', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.CommissionedChargedWeight'), field: 'chargeWeight', width: 180, colId: 'chargeWeight', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.ActualQuantity'), field: 'quantityActual', width: 180, colId: 'quantityActual', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 0)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.ActualWeight'), field: 'weightActual', width: 180, colId: 'weightActual', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.ActualVolume'), field: 'cubageActual', width: 180, colId: 'cubageActual', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.ActualChargedWeight'), field: 'cWeight', width: 180, colId: 'cWeight', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'), field: 'cargoChineseName', width: 180, colId: 'cargoChineseName', enableRowGroup: true },
        { headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'), field: 'cargoEnglishName', width: 180, colId: 'cargoEnglishName', enableRowGroup: true },
        { headerName: this.$t('SeaExport.BangPic'), field: '', width: 180 },
        { headerName: this.$t('SeaExport.PrintingPlatePhotos'), field: '', width: 180 },
        { headerName: this.$t('SeaExport.SolicitationType'), field: 'cargoSource', width: 180, colId: 'cargoSource', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value, 3)
          }
        },
        { headerName: this.$t('SeaExport.DateOfDeparture'), field: 'etd', width: 180, colId: 'etd', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.ActualDateOfDeparture'), field: 'atd', width: 180, colId: 'eta', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.DateOfArrival'), field: 'eta', width: 180, colId: 'ata', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.DateOfCreation'), field: 'dateCreated', width: 180, colId: 'dateCreated', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.StatusOfCustomsDeclaration'), field: 'declareCustomsState', width: 180, colId: 'declareCustomsState', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.customsStateLabFun(Number(params.value))
          }
        },
        { headerName: this.$t('SeaExport.ProtocolType'), field: 'protocolType', width: 180, colId: 'protocolType', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.protocolTypeLabFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.Operation'), field: 'op', width: 180, colId: 'op', enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op') : ''
          }
        },
        { headerName: this.$t('SeaExport.Sales'), field: 'sales', width: 180, colId: 'sales', enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_sales') : ''
          }
        },
        { headerName: this.$t('SeaExport.Accrued'), field: 'provisioned', width: 180, colId: 'provisioned', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        { headerName: this.$t('SeaExport.AirlinePerson2'), field: 'planner', width: 180, colId: 'planner', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.CustomerService'), field: 'csr', width: 180, colId: 'csr', enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_csr') : ''
          }
        },
        { headerName: this.$t('SeaExport.Documents'), field: 'dc', width: 180, colId: 'dc', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.FieldOperation'), field: 'siteOp', width: 180, colId: 'siteOp', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.OverseaOperation'), field: 'overseaOp', width: 180, colId: 'overseaOp', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.ShutOut'), field: 'shutOut', width: 180, colId: 'shutOut', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        { headerName: this.$t('SeaExport.BusinessCreator'), field: 'createdBy', width: 180, colId: 'createdBy', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.PreverifyStatus'), field: 'preverifyState', width: 180, colId: 'preverifyState', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.getPreverifyStateCN(Number(params.value))
          }
        },
        { headerName: this.$t('SeaExport.BusinessStatus'), field: 'jobState', width: 180, colId: 'jobState',
          cellRenderer: (params) => {
            if (params.data && params.value && Number(params.value) === -1 && params.data['preverifyState'] && Number(params.data['preverifyState']) === 2 && this.btn.pretrialReviewConfig) {
              return this.$t('SeaExport.StateVerifyingReview')
            }
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          }
        },
        { headerName: this.$t('SeaExport.Auditor'), field: 'preVerifier', width: 180, colId: 'preVerifier', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.preverifyDate'), field: 'preVerifyDate', width: 180, colId: 'preVerifyDate', hide: true, enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.OtherWarehouseNotes'), field: 'otherWarehouseNotes', width: 180, hide: true, colId: 'otherWarehouseNotes', enableRowGroup: true },
        { headerName: this.$t('SeaExport.CustomJobType'), field: 'customJobType', width: 180, colId: 'customJobType', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.value, 'name', SystemConstants.AE.code, false)
          }
        },
        { headerName: this.$t('SeaExport.SOPStatus'), field: 'sopState', width: 180, colId: 'sopState', enableRowGroup: true, tooltipValueGetter: (params) => params.value },
        { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'userDefinedField1', width: 180, hide: true, colId: 'userDefinedField1', enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'userDefinedField2', width: 180, hide: true, colId: 'userDefinedField2', enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'userDefinedField3', width: 180, hide: true, colId: 'userDefinedField3', enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField4'), field: 'userDefinedField4', width: 180, hide: true, colId: 'userDefinedField4', enableRowGroup: true },
        { headerName: this.$t('SeaExport.OperationDate'), field: 'customsDate', width: 180, colId: 'customsDate', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.ManageAuditStatus'), field: 'manageAuditStatus', width: 180, colId: 'manageAuditStatus', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.manageAuditStatusLabelFunction(params.value)
          }
        },
        { headerName: this.$t('SeaExport.DocCutOffDate'), field: 'fileCutoff', width: 180, colId: 'fileCutoff', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.HBLShipper'), field: 'hblShipperLine1', width: 180, colId: 'hblShipperLine1', enableRowGroup: true },
        { headerName: this.$t('SeaExport.HBLConsignee'), field: 'hblConsigneeLine1', width: 180, colId: 'hblConsigneeLine1', enableRowGroup: true },
        { headerName: this.$t('SeaExport.HBLNotifier'), field: 'hblNotifyLine1', width: 180, colId: 'hblNotifyLine1', enableRowGroup: true },
        { headerName: this.$t('SeaExport.TradeTerms2'), field: 'incoTerm', width: 180, hide: true, colId: 'incoTerm', enableRowGroup: true },
        { headerName: this.$t('SeaExport.PlaceOfDelivery'), field: 'destinationPlace', width: 180, hide: true, colId: 'destinationPlace', enableRowGroup: true }, {
          headerName: this.$t('SeaExport.quotationNum'),
          colId: 'quotationNo',
          field: 'quotationNo',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ProjectName'),
          field: 'projectName',
          colId: 'projectName',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ProjectBatch'),
          field: 'projectBatch',
          colId: 'projectBatch',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('queryJob.CommissionedDensity'),
          field: 'densityContract',
          hide: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: params => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
          }
        }, {
          headerName: this.$t('queryJob.ActualDensity'),
          field: 'densityActual',
          hide: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: params => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
          }
        },
        { headerName: this.$t('queryJob.totalIncome'), colId: 'income', field: 'income', width: 180,
          hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('queryJob.totalCost'), colId: 'cost', field: 'cost', width: 180,
          hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        },
        { headerName: this.$t('FinanceManage.charge_profitAll'), colId: 'realProfit', field: 'realProfit', width: 180,
          hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          },
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          colId: 'remarks',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateStatus'),
          colId: 'cooperateStatus',
          field: 'cooperateStatus',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.cooperateStatusLabelFunc(Number(params.value))
          },
          hide: !this.useOrderCenterMode,
          width: 100, minWidth: 100
        },
        {
          headerName: this.$t('queryJob.EstimatedReviewer'),
          field: 'preverifier',
          colId: 'preVerifier',
          width: 180,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('queryJob.DateOfPreReview'),
          field: 'preVerifyDate',
          colId: 'preVerifyDate',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Message.Customer_Service'),
          colId: 'csrDepartment',
          field: 'csrDepartment',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('Message.Documentation_Department'),
          colId: 'dcDepartment',
          field: 'dcDepartment',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.AirlineDepartment'),
          colId: 'plannerDepartment',
          field: 'plannerDepartment',
          width: 140,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.Marks'),
          field: 'mark',
          colId: 'mark',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerOffice'),
          field: 'csrOffice',
          colId: 'csrOffice',
          hide: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.DocumentOffice'),
          field: 'dcOffice',
          colId: 'dcOffice',
          hide: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.ChannelNo'),
          field: 'channelNo',
          colId: 'channelNo',
          enableRowGroup: true,
          hide: true,
          width: 100
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
          field: 'userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          enableRowGroup: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
          field: 'userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          enableRowGroup: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole3'),
          field: 'userDefinedRoleId3',
          colId: 'userDefinedRoleId3',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole4'),
          field: 'userDefinedRoleId4',
          colId: 'userDefinedRoleId4',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole5'),
          field: 'userDefinedRoleId5',
          colId: 'userDefinedRoleId5',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole6'),
          field: 'userDefinedRoleId6',
          colId: 'userDefinedRoleId6',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole7'),
          field: 'userDefinedRoleId7',
          colId: 'userDefinedRoleId7',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }
      )
      if (this.isZY) {
        result.push(
          {
            headerName: this.$t('CargoMsg.AllowSaleProduct'),
            field: 'saleProductCode',
            colId: 'saleProductCode',
            enableRowGroup: true,
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AllowSaleProduct, 'productCode', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.FullOrInside'),
            field: 'fullOrInside',
            colId: 'fullOrInside',
            enableRowGroup: true,
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.fullOrInsideLabelFun(Number(params.value))
            }
          }
        )
      }
      return result
    },
    customSearchItems() { // 自定义高级查询项
      return this.getCustomSearchItems()
    },
    btnCooperateEnable() {
      return this.selectedJob ? (this.isCooperate(this.selectedJob.cooperateStatus) && [SystemConstants.COOPERATE_STATUS_PENDING.code].includes(this.selectedJob.cooperateStatus)) : false
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    },
    finalColumnDefs() {
      if (this.$store.state.uiCustom.enable) {
        return UICustomUtil.handleColumnDefs(UICustomConstants.AIR_BOOKING_VERIFY, this.$store.getters.currentOfficeId, this.columnDefs)
      }
      return this.columnDefs
    }
  },
  async created() {
    await this.preloadBasicData()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
    await this.preloadBasicData()
    this.queryLastModifyBookingByDay()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBusinessInfo', function() {
      context.showBusinessInfo()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 查询最近几天的业务
    queryLastModifyBookingByDay() {
      this.loading = getLoading()
      this.filter.pageNum = 1
      this.filter.pageSize = this.filter.pageSize
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.createdBy = this.$store.getters.userId
      const conditions = []
      const condition = new AdvancedSearchOption(null, 'job.OP_OFFICE', this.$store.getters.currentOfficeId, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
      const condition2 = new AdvancedSearchOption(null, 'job.JOB_STATE', SystemConstants.STATE_VERIFYING.code, AdvancedSearchConsts.OPERATOR_EQUAL.code)
      conditions.push(condition2.formatObj2Json())
      const condition3 = new AdvancedSearchOption(null, 'job.PREVERIFY_STATE', SystemConstants.VERIFYING_PENDING.code, AdvancedSearchConsts.OPERATOR_EQUAL.code)
      conditions.push(condition3.formatObj2Json())
      this.filter.conditions = conditions
      queryLastModifyBookingByDay(this.filter).then(res => this.handleQueryData(res))
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedJob = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const nodeJob = node.data
            if (nodeJob.jobUuid) this.selectedJob = nodeJob
          }
        })
      }
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    // 行首多选框勾选事件
    onRowSelected(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      if (event.node.isSelected()) {
        this.onRowClicked(event)
      }
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      const node = event.data
      if (node.jobUuid) this.selectedJob = node
    },
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
      this.creditRestrictionForBooking = parseInt(cache.config.get('CreditRestrictionForBooking'))
      this.btn.pretrialReviewConfig = parseInt(cache.config.get('PretrialReviewAE')) === 1
      this.useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      this.allowPartialCheckPass = Number(cache.config.get('allowPartialCheckPass')) === 1
      this.salesCanSeeBookingAgent = Number(cache.config.get('SalesCanSeeBookingAgent')) === 1
      this.isZY = String(cache.config.get('ToExoSystem')) === 'zy'
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
      this.airMblDisplayStyle = Number(cache.config.get('AirMblDisplayStyle')) === 1
      this.init()
    },
    init() {
      this.btn.acceptRole = this.$checkPermission(['button_AEPreVerify_accept'])
      this.btn.rejectRole = this.$checkPermission(['button_AEPreVerify_reject'])
      this.btn.reviewThrough = this.$checkPermission(['button_AEPreVerify_reviewThrough'])
      this.btn.reviewRefusal = this.$checkPermission(['button_AEPreVerify_reviewRefusal'])
    },
    // 组装查询条件
    getCustomSearchItems() {
      const defaultSearchFields = []
      // 预审状态
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'job.PREVERIFY_STATE'
      searchField.itemLabel = 'SeaExport.PreverifyStatus'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dataCacheKey = 'local_cache_SystemConstants$VERIFY_STATES'
      searchField.dataCacheKey = ''
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = this.btn.pretrialReviewConfig ? SystemConstants.VERIFY_STATES_REVIEW : SystemConstants.VERIFY_STATES
      defaultSearchFields.push(searchField.formatObj2Json())
      if (this.useOrderCenterMode && !this.orderCenterBranch && this.approveCooperationBusiness) {
        // 协作状态
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.COOPERATE_STATUS'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateStatus'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = Array.from(SystemConstants.COOPERATE_STATUS)
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      if (!this.bookingAgentVisible) {
        // 移除订舱代理
        searchField = new AdvancedSearchField()
        searchField.itemType = 'company'
        searchField.subType = {
          'type': 'bookingAgent',
          'tagValue': 'cmpIdx'
        }
        searchField.fieldType = 'FIELD_BOOKING_AGENT'
        searchField.itemName = 'job.BOOKING_AGENT'
        searchField.itemLabel = 'SeaExport.BookingAgent'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 委托单位
      searchField = new AdvancedSearchField()
      searchField.itemType = 'company'
      searchField.subType = {
        'type': 'customer',
        'tagValue': 'cmpIdx',
        'useSales': true
      }
      searchField.fieldType = 'FIELD_CUSTOMER'
      searchField.itemName = 'job.CUSTOMER_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_AuthorizedClient'
      searchField.defaultSelected = 1
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())
      // 中邮-可售卖产品和国内国外
      if (this.isZY) {
        const saleProductList = getFilterCacheList(TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
          return mapping.statusEnabled === true && mapping.airExportEnabled === true
        })
        // 可售卖产品
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
        searchField.itemName = 'job.SALE_PRODUCT_CODE'
        searchField.itemLabel = 'CargoMsg.AllowSaleProduct'
        searchField.tagValue = 'productCode'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = saleProductList
        defaultSearchFields.push(searchField.formatObj2Json())

        // 全程/国内
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'job.FULL_OR_INSIDE'
        searchField.itemLabel = 'CargoMsg.FullOrInside'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = Array.from(SystemConstants.FULL_OR_INSIDE)
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.$store.state.uiCustom.enable) {
        UICustomUtil.handleSearchItems(UICustomConstants.AIR_BOOKING_VERIFY, this.defaultSearchItems, defaultSearchFields)
      }
      return defaultSearchFields
    },
    // 查询[简单查询/高级查询]
    toQuery() {
      this.filter.pageNum = 1
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.filter.jobNo = ''
      this.filter.conditions = []
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = [... data] // 高级查询条件（点击查询时的快照状态）
        this.filter.conditions = [... data]
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(this.filter.conditions)
      }
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.PREVERIFY_STATE', data)) {
        const jobStates = [SystemConstants.STATE_VERIFYING.code]
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, AdvancedSearchConsts.OPERATOR_IN.code)
        this.filter.conditions.push(option.formatObj2Json())
      }
      // 业务状态追踪
      const trackingOption = AdvancedSearchOption.removeOption('job.tracking', data)
      if (trackingOption && trackingOption.value) {
        const tracking = trackingOption.value['tracking']
        const trackingDetails = trackingOption.value['trackingDetails']
        const detailCodes = []
        for (const detail of trackingDetails) {
          detailCodes.push(detail.code)
        }
        this.filter.conditions.push(new AdvancedSearchOption(null, 'trackingInfo.CODE', tracking.code, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
        this.filter.conditions.push(new AdvancedSearchOption(null, 'trackingInfo.SUB_CODE', detailCodes, AdvancedSearchConsts.OPERATOR_IN.code))
      }
      this.filter.pageNum = this.filter.pageNum
      this.filter.pageSize = this.filter.pageSize
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.appendQuery = this.appendQuery
      this.filter.verifyModel = true
      // CARGO-34647 空运出口订舱预审界面用高级检索功能输入订单号不能查询到订单
      // 操作分公司
      // const officeId = this.$store.getters.currentOfficeId
      // if (officeId && officeId > 0) {
      //   this.filter.conditions.push(new AdvancedSearchOption(null, 'job.OP_OFFICE', officeId, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      // }
      this.loading = getLoading()
      if (this.notRefresh) {
        console.log('请等上次查询完再执行查询操作')
        return
      }
      this.notRefresh = true
      advancedQuery(this.filter).then(res => this.handleQueryData(res)).catch(() => {
        this.loading.close()
      }).finally(() => {
        this.notRefresh = false
      })
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      this.loading = getLoading()
      this.context.loading = true
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword.trim()
        this.filter.pageNum = 1
      }
      this.filter.pageNum = this.filter.pageNum
      this.filter.pageSize = this.filter.pageSize
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.conditions = []
      this.filter.verifyModel = true
      const conditions = []
      const preverifyStates = [1, 2, 3]
      const condition = new AdvancedSearchOption(null, 'job.PREVERIFY_STATE', preverifyStates, AdvancedSearchConsts.OPERATOR_IN.code)
      conditions.push(condition.formatObj2Json())
      const jobStates = [SystemConstants.STATE_VERIFYING.code]
      const option = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, AdvancedSearchConsts.OPERATOR_IN.code)
      conditions.push(option.formatObj2Json())
      this.filter.conditions = conditions
      advancedQuery(this.filter).then(res => this.handleQueryData(res)).catch(() => {
        this.loading.close()
        this.context.loading = false
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      let results = res.data.list
      if (this.appendQuery) { // 追加查询数据去重
        results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
        this.total = results.length
      } else {
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
        this.pageCount = res.data.pages
      }
      this.rowData = results
      this.selectedJob = null
      this.selectedRowCount = 0
      if (this.gridApi) this.gridApi.clearFocusedCell()
      this.loading.close()
    },
    // 查看
    toLook(row) {
      if (!row) {
        row = this.selectedJob || this.readSelectedRows()[0]
      }
      this.$emit('look', row)
    },
    // 新增
    onAdd() {
      this.$emit('add')
    },
    // 审核通过
    acceptHandler() {
      if (!this.selectedJob) {
        this.$message.warning(this.$t('SeaExport.SelectARecord'))
        return
      }
      this.acceptDialog.jobs = this.readSelectedRows(false)
      if (!this.acceptDialog.jobs || this.acceptDialog.jobs.length <= 0) {
        this.$message.warning(this.$t('SeaExport.CheckApproved'))
        return
      }
      // 协作状态: 审核通过
      const cooperateList = []
      for (const seaJob of this.acceptDialog.jobs) {
        if (this.isCooperate(seaJob.cooperateStatus)) { cooperateList.push(seaJob.uuid) }
      }
      if (cooperateList.length > 0) {
        if (cooperateList.length !== this.acceptDialog.jobs.length) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CooperateReviewSeparately'))
          return
        }
        this.acceptCooperateHandler(cooperateList)
        return
      }
      const jobArr = []
      for (const job of this.acceptDialog.jobs) {
        if (job.jobState !== -1 || job.preverifyState === 2 || job.preverifyState === 3) {
          jobArr.push(job.jobNo)
        }
        if (this.btn.pretrialReviewConfig && (job.preverifyState === 5 || job.preverifyState === 6)) {
          jobArr.push(job.jobNo)
        }
      }
      if (jobArr.length > 0) {
        const str = this.btn.pretrialReviewConfig ? `${this.$t('Message.Approved')}/${this.$t('CargoMsg.Cargo_Denied')}/${this.$t('SeaExport.VerifyReviewThrough')}/${this.$t('SeaExport.ReviewRejectedBusinessNumber')}` : `${this.$t('Message.Approved')}/${this.$t('SeaExport.RejectedBusinessNumber')}`
        const h = this.$createElement
        const content = h('div', null, [
          h('p', { style: 'overflow-wrap: break-word;' }, jobArr.join(','))
        ])
        this.$alert(content, str)
        return
      }
      this.acceptDialog.job = this.acceptDialog.jobs[0]
      this.acceptDialog.submitCallBack = this.acceptSubmitCallBack
      this.acceptDialog.visible = true
    },
    // 审核通过回调函数
    acceptSubmitCallBack(result) {
      this.acceptDialog.result = result
      if (result) {
        const jobKeys = Array.from(this.acceptDialog.jobs, p => p.uuid)
        this.acceptDialog.result.jobKeys = jobKeys
        const callBack = () => { batchCheckJobsCredit(jobKeys).then(res => this.checkCreditResultHandler(res)) }
        // 判断是否开启验证规则
        if (this.useCheckRule) {
          const checkNode = CheckRuleConstants.NODE_BOOKING_VERIFY.code
          // const hasCheckRule = await JobUtils.hasConfigCheckRuleByJobs(checkNode, jobKeys, 'AE')
          const hasCheckRule = true
          if (hasCheckRule) {
            this.batchCheckingWindow.jobs = this.acceptDialog.jobs
            if (this.allowPartialCheckPass) {
              this.checkingManager(this.acceptDialog.jobs, checkNode, callBack, null, true, result)
            } else {
              this.checkingManager(this.acceptDialog.jobs, checkNode, callBack, null, false, result)
            }
          } else {
            callBack()
          }
        } else {
          callBack()
        }
      }
    },
    //  验证规则配置公用
    checkingManager(jobs, checkNode, callBack, callBack2, allowPartialCheckPass = false, newJob = null) {
      if (jobs && jobs.length > 0) { // 批量验证
        this.batchCheckingWindow.checkNode = checkNode
        this.batchCheckingWindow.jobs = jobs
        this.batchCheckingWindow.allowPartialCheckPass = allowPartialCheckPass
        this.batchCheckingWindow.callBack = callBack
        this.batchCheckingWindow.callBack2 = callBack2
        this.batchCheckingWindow.newJob = newJob
        this.batchCheckingWindow.visible = true
      }
    },
    // 信控验证返回结果
    checkCreditResultHandler(res) {
      const result = res.data
      if (result && this.creditRestrictionForBooking !== 0) {
        if (this.creditRestrictionForBooking === 2) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipOne')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = false
          this.confirmDialogWindow.confirmCallBack = null
          this.confirmDialogWindow.visible = true
          return
        }
        if (this.creditRestrictionForBooking === 1) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipTwo')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = true
          this.confirmDialogWindow.confirmCallBack = this.batchAudit
          this.confirmDialogWindow.visible = true
          return
        }
      }
      this.batchAudit()
    },
    // 审核通过
    batchAudit() {
      acceptJob(this.acceptDialog.result).then(res => {
        this.$message.success(this.$t('AirExport.ReviewSucceeded'))
        this.toQuery()
        this.selectedJob = null
        this.gridApi.clearFocusedCell()
      })
    },
    // 拒绝
    rejectHandler() {
      const jobs = this.readSelectedRows(false)
      if (!jobs || jobs.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      // 协作业务不支持批量拒绝
      if (jobs.length > 1) {
        for (const job of jobs) {
          if (this.isCooperate(job.cooperateStatus)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CollabBatchRejectError', [job.jobNo]))
            return
          }
        }
      }
      let rejectCallBack = this.rejectCallBackHandler
      if (jobs.length === 1) {
        const job = jobs[0]
        if (this.isCooperate(job.cooperateStatus)) {
          rejectCallBack = this.rejectCooperateCallBackHandler
        }
      }
      this.rejectWindow.jobNo = this.selectedJob ? this.selectedJob.jobNo : ''
      this.rejectWindow.jobList = jobs
      this.rejectWindow.rejectCallBack = rejectCallBack
      this.rejectWindow.visible = true
    },
    // 拒绝回调函数
    rejectCallBackHandler(remark) {
      const jobs = this.readSelectedRows(false)
      if (!jobs || jobs.length === 0) {
        return
      }
      const jobKeys = Array.from(jobs, p => p.uuid)
      batchPreVerifyReject({ 'jobKey': jobKeys, 'remark': remark }).then(res => {
        this.$message.success(this.$t('SeaExport.RefuseSuccess'))
        this.toQuery()
        this.selectedJob = null
        this.gridApi.clearFocusedCell()
      })
    },
    // 获取选中行
    readSelectedRows(tips = true) {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0 && tips) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 复制
    copyJobHandler() {
      if (!this.selectedJob) {
        this.$message.info(this.$t('Message.SelectJob'))
        return
      }
      this.$emit('copy', this.selectedJob)
    },
    // 列表 业务编号旁边搜索框的打印
    showBusinessInfo(e) {
      stopBubble(e)
      if (!this.selectedJob) return
      this.templateSelectorDialog.ctx = new AirExportJob(this.selectedJob)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedJob.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 选中父级自动勾选子集，取消选中类似
    treeDataRowSelectedCallBack(p) {
      // return
      if (p.data.root) {
        if (p.node.selected) {
          p.node.childrenAfterGroup.forEach((node) => {
            node.setSelected(p.node.selected)
          })
        } else {
          const isTrue = p.node.childrenAfterGroup.filter(
            (node) => node.selected
          )
          if (isTrue.length === p.node.childrenAfterGroup.length) {
            p.node.childrenAfterGroup.forEach((node) => {
              node.setSelected(p.node.selected)
            })
          }
        }
      } else {
        if (!p.node.selected) {
          if (p.node.parent.selected) {
            p.node.parent.setSelected(false)
          }
        } else {
          const brothers = p.node.parent.childrenAfterGroup
          const selected = brothers.filter((node) => node.selected)
          if (selected.length === brothers.length) {
            p.node.parent.setSelected(true)
          }
        }
      }
    },
    // 复核通过 preverifyState = 5
    btVerifyReviewThroughHandler() {
      if (!this.selectedJob || !this.selectedJob.uuid) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      const jobs = this.readSelectedRows(false)
      if (!jobs || jobs.length <= 0) {
        this.$message.warning(this.$t('SeaExport.CheckApproved'))
        return
      }
      const jobNos = []
      for (const job of jobs) {
        if (this.isCooperate(job.cooperateStatus)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CooperateNoPretrialReview'))
          return
        }
        if (!(parseInt(job.jobState) === -1 && parseInt(job.preverifyState) === 2)) {
          jobNos.push(job.jobNo)
        }
      }
      if (jobNos.length > 0) {
        const h = this.$createElement
        const content = h('div', null, [
          h('p', { style: 'overflow-wrap: break-word;' }, jobNos.join(','))
        ])
        this.$alert(content, this.$t('SeaExport.UnreviewedBusinessNumber2'))
        return
      }
      const jobKeys = Array.from(jobs, p => p.uuid)
      const item = {}
      item.uuid = jobKeys[0]
      item.preverifyState = 5
      item.jobKeys = jobKeys
      this.loading = getLoading()
      reviewThrough(item).then(res => {
        this.$message.success(this.$t('SeaExport.ReviewSuccess'))
        this.toQuery()
        this.selectedJob = null
        this.gridApi.clearFocusedCell()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 复核拒绝 preverifyState = 6
    btVerifyReviewRefusalHandler() {
      if (!this.selectedJob || !this.selectedJob.uuid) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      if (this.isCooperate(this.selectedJob.cooperateStatus)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CooperateNoPretrialReview'))
        return
      }
      this.loading = getLoading()
      const item = {}
      item.uuid = this.selectedJob.uuid
      item.preverifyState = 6
      reviewRefusal(item).then(res => {
        this.$message.success(this.$t('SeaExport.ReviewRejectedSuccess'))
        this.toQuery()
        this.selectedJob = null
        this.gridApi.clearFocusedCell()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 是否协作状态
    isCooperate(cooperateStatus) {
      console.log('isCooperate', cooperateStatus)
      if (cooperateStatus !== -1 && this.useOrderCenterMode && this.approveCooperationBusiness) {
        return true
      }
      return false
    },
    // 协作状态: 审核通过
    acceptCooperateHandler(cooperateList) {
      if (!cooperateList || cooperateList.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.cooperationVerifyDialog.jobUuids = cooperateList
      this.cooperationVerifyDialog.jobUuid = this.selectedJob.uuid // 显示其中一笔
      const cooperate = {
        branchId: this.selectedJob.cooperateBranchId,
        opId: this.selectedJob.cooperateOpId,
        csrId: this.selectedJob.cooperateCsrId,
        overseaOp: this.selectedJob.cooperateOverseaOp,
        dcId: this.selectedJob.cooperateDcId,
        planner: this.selectedJob.cooperatePlanner,
        sales: this.selectedJob.cooperateSales,
        cargoSalesId: this.selectedJob.cooperateCargoSalesId,
        userDefinedRoleId1: this.selectedJob.cooperateUserDefinedRoleId1,
        userDefinedRoleId2: this.selectedJob.cooperateUserDefinedRoleId2,
        businessType: this.selectedJob.cooperateBusinessTypeCode ? this.selectedJob.cooperateBusinessTypeCode.split(',') : []
      }
      this.cooperationVerifyDialog.cooperate = cooperate
      this.cooperationVerifyDialog.editable = false
      this.cooperationVerifyDialog.visible = true
    },
    toAcceptCooperationVerifyCallBack(remark) {
      this.loading = getLoading()
      updateState({ jobUuids: this.cooperationVerifyDialog.jobUuids, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_APPROVED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
          this.toQuery()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 协作状态: 拒绝
    rejectCooperateCallBackHandler(remark) {
      this.loading = getLoading()
      updateState({ jobUuid: this.selectedJob.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_REFUSED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.$message.success(this.$t('SeaExport.RefuseSuccess'))
          this.toQuery()
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
  #app #verify-tree-grid {
    .not-click {
      pointer-events: none;
      button {
        color: #fff;
        background-color: #8cc8ff;
        border-color: #acbcca;
        cursor: not-allowed;
      }
    }
    button.not-click {
      color: #fff;
      background-color: #8cc8ff;
      border-color: #8cc8ff;
      cursor: not-allowed;
    }
  }
</style>
